import { render, staticRenderFns } from "./DialogMensaje.vue?vue&type=template&id=91d7b32c&scoped=true"
import script from "./DialogMensaje.vue?vue&type=script&lang=js"
export * from "./DialogMensaje.vue?vue&type=script&lang=js"
import style0 from "./DialogMensaje.vue?vue&type=style&index=0&id=91d7b32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d7b32c",
  null
  
)

export default component.exports